module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-005"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Introduction")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("1. The nature of the book of Esther")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("What kind of book is Esther? It is this question that taunts us as we try to understand the significance of this short OT book. On the one hand it appears to be a simple historical account. On the other it is a carefully crafted piece of literary genius. From one perspective, its main focus is upon the individual who gives the book its name; from another the spotlight is on a whole nation. Thematically and stylistically there is both simplicity and complexity, a transparency that is mixed with intrigue. Theologically there are obvious implications of the story, but there is also mystery and dilemma. Ethically, good triumphs over evil, but does the end justify the means along the way? Is the book relevant or irrelevant? Is it to be enjoyed at a surface level or penetrated for its hidden depths? Is it meant to convey historical facts, or is its meaning to be found in application to our lives? Is its value for one nation or many, or for individual people? What is the "), _c('i', [_vm._v("raison d’être ")]), _vm._v("of the book of Esther?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("These questions are reminiscent of those we sometimes pose of the parables of Jesus. We are fully aware that a full explanation of their details and their meaning somehow escapes us. The New Testament scholar C. H. Dodd claims that the parables ‘leave us in sufficient doubt about their precise application in order to tease our minds into active thought’ (1961: 16). This is at least part of Esther’s compelling quality. The story taunts and teases us. As soon as we think we are beginning to understand its themes or its literary features, we become alert to our own dissatisfaction with our perception. But rather than being deterred, we become more absorbed. Take, for example, the fact that God’s name is never mentioned in the text. Instead of giving up on a theological quest, we find ourselves searching more earnestly for a God whose non-appearance seems to enhance his presence. The result is that, because our minds are teased, our subsequent theological conclusions incorporate reflection at a number of penetrating and intriguing levels.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("This, of course, is similar to our responses to personal testimonies about journeys of faith. Testimonies are our life stories – how life began for us, how we came to experience salvation through Christ, how life has continued for us. It is my contention that the value and meaning of the book of Esther lies in its testimonial value. In this book we read of Esther’s early life (living with her uncle in the Persian Empire). We read what life is like for Esther when she encounters deliverance and salvation (her unenviable position in the king’s palace), and her active acceptance of her own role within these processes ("), _c('i', [_vm._v("for such a time as this, ")]), _vm._v("Esth. 4:14). The story is concluded by the description of what life is like for Esther after this particular event of deliverance, but somehow it is a story that remains ongoing and is open-ended. Another way of reading the story is to understand that it represents the testimony not of Esther alone but of her people together. This adds further significance to the references to the establishment of the Purim festival at the end of the book. Life now will never be the same for Esther’s people. An encounter with salvation always has lasting and wide-ranging effects, encompassing its original participants as well as those to whom the testimony is conveyed. This, after all, is Scripture, and Scripture is a document of faith, the story of salvation – history that deserves to ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("be heard and that teases its every hearer into active thought as well as personal and corporate reflection.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("2. Origin and date")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The book of Esther clearly emerged within the general time band between 465 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC ")]), _vm._v("(the end of the reign of Ahasuerus) and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("70 (when Josephus made full use of the story in his "), _c('i', [_vm._v("Antiquities")]), _vm._v(").")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN1",
      "id": "ap_NFIN1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The question is, can this time band be narrowed further? The earliest date would allow the author to be a contemporary of the events described which occurred immediately following Ahasuerus’ reign. Esther 1:1 may imply that time has elapsed since Ahasuerus’ reign, and therefore the events described would have happened in the reign of Artaxerxes (464–423 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). If this is indeed the implication, then a late fifth-century "), _c('i', [_vm._v("terminus a quo ")]), _vm._v("is established. It seems that the book reflects a Persian setting (the Persian period lasting from Cyrus’ capture of Babylon in 539 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" until Alexander captured Tyre in 333/2 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") but this does not mean that the final form of the book was settled during this era."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN2",
      "id": "ap_NFIN2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A look at the internal evidence has led many to conclude that a third-century Hellenistic date of writing is probable."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN3",
      "id": "ap_NFIN3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" To support this argument scholars have drawn on the evidence of the second-century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC ")]), _vm._v("Qumran Scrolls, which seem to present a Hebrew language later than that found in the book of Esther."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN4",
      "id": "ap_NFIN4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Having "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("established a pre-second-century dating for Esther on the basis of the diction, idiom and syntax of the Hebrew text, Driver (1960: 484, followed by many others) settled on a third-century date.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("But this traditional date has not been universally accepted. Recently, importance has been assigned to the dating formulas within the book of Esther itself. Friedberg argues that these formulas lead to the probability that Esther was written at a much earlier date. He asserts that the post-exilic books show a development in dating formulas, moving away from the traditional numerical system (where months are not given names but referred to by numerals, beginning at spring time), to the complete adoption of the Babylonian system of names for months (i.e. month 1 becomes Nisan etc) – a process that is complete in Ezra-Nehemiah (second half of the fourth century). Friedberg shows that Esther lies in the middle of this post-exilic process, because it uses mixed formulas, indicating that the process to full use of the Babylonian system had begun but was not completed, and therefore concludes that a late fifth-century date for Esther is most probable.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN5",
      "id": "ap_NFIN5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It seems that at least the possibility of a late fifth-century date for Esther has been established. Furthermore, it is likely that Esther was written within the Persian period, not least because the story is most meaningful within that setting, and the absence of reference to Hellenistic culture supports this. This reduces the time band for Esther to between late fifth century and the first half of the fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", a time span consistent with the internal and linguistic evidence within the book itself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN6",
      "id": "ap_NFIN6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3. Historical background and setting")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("While questions about the historical reliability of the Esther story will be addressed in a later section (p. 30), it is necessary here to "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("consider the historical setting in which this story emerges.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The origin of this book, by virtue of its dating, language and thematic content, is firmly fixed within the Persian Empire governed by the Achaemenid kings. Between 545 and 538 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", the Achaemenid kings conquered the whole of the Middle East (including Palestine) and had established the largest of all the empires in the ancient world. Cyrus (559–530 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") was particularly responsible for the extension of the Empire’s borders, and although his military advances were quite conclusive, even ruthless, he treated people within his Empire with respect, seeing himself as their liberator rather than a tyrant. Cyrus (who is portrayed as the servant of the Lord in Isaiah 45) allowed the Jewish people to return to Palestine at the end of the Babylonian exile (539 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") in order to rebuild the temple. Cyrus was followed by Cambyses II (530–522 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("), who spent much of his time occupied with advances into Egypt, and then by Darius (522–486 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v("). During this time, the Empire’s power was consolidated, despite internal power struggles (Darius’ ascension was by no means straightforward), and administrative structures were developed, including the division of the Empire into satrapies and smaller sub-provinces. Darius was also responsible for the palace complex built at Susa (the ancient capital of Elam, modern-day Iran). After Darius came Xerxes (Ahasuerus, 486–465 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") in whose reign the story of Esther is set (Esth. 1:1), and then Artaxerxes I (464–423 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") in whose reign the first version of the story probably emerged.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("This period was dominated by territorial concerns and intellectual advances. Xerxes himself lost strategic battles with the Greeks at a time when Greek culture flourished in Athens with the emergence of Socrates, Pericles and Pythagorus. Our main evidence about this era comes from Herodotus, the Greek historian, whose "), _c('i', [_vm._v("Histories of the Persian Wars ")]), _vm._v("(490–480 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") tell us about the Persian kings and their campaigns. Although we must be cautious about the reliability of Herodotus’ accounts (he was after all a Greek writer whose allegiance to the Greek people would have made him an enemy of the Persian Empire), his writings do bear evidence to Persian personalities and practice. For example, Herodotus describes Xerxes as tall and handsome, an ambitious ruler and warrior. It appears that Herodotus was quite fascinated by Xerxes, ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("because about a third of his history book is taken up with his reign. Further information about Xerxes is available in the Behistun Inscription of Darius that contains the Persian records of the Empire. Here Xerxes is portrayed as a successful ruler who quelled revolts in Babylon and Egypt – certainly in Babylon he ordered hard penalties, not least the destruction of the temple and statue of the Babylonian god Marduk.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("So the story of Esther finds its meaning within such a setting. It concerns the fate of a group of Jews, who, about fifty or sixty years after being allowed to return to Jerusalem, still found themselves in the eastern Persian Empire. Their situation was not easy. While some Jews clearly rose to prominence (compare the evidence in the book of Daniel), the kings were lenient towards them only to a point, and any hint of subversive activity was treated ruthlessly. This volatile situation lies behind the drama of the Esther story – for its first readers the tension would need no explanation. To this, the religious tension needs to be added. We know that Xerxes completed the palace at Persepolis, in honour of himself and the Zoroastrian god Ahuramazda (having removed the worship of Daiva, the old Iranian god).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" To a king who made religious concerns his business, the Jewish population with their own religion and customs would be viewed as particularly troublesome. Against such a background, was there any hope for God’s people? It is therefore the historical setting of this story that imbibes it with theological meaning.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("4. Canonical status")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The acceptance of Esther into the OT canon was not straightforward. To some extent, our knowledge of the process raises as many questions as it provides answers.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The process of the establishment of the canon of the OT as a whole is itself problematic. There is no widespread agreement about when the OT canon was finally agreed, or the timing of steps towards "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("it. Most scholars concur that the Jewish canon reached a point of closure some time between 200 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC ")]), _vm._v("and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("200.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Prior to the second century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(", most of our information about the canon’s development comes from three Jewish sources: evidence from Qumran (150 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC ")]), _vm._v("– "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("70), Josephus ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("90), and the early rabbinical writings. These sources give clues about Esther’s early place within the OT canon:")]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab00a"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "1",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "9%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("(i)")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Qumran:")]), _vm._v(" Esther is the only book of our present OT canon that is not found among the Qumran Scrolls. While it has been argued that this suggests Esther did not enjoy early acceptance, it could equally be because the Essene community did not celebrate the festival of Purim, and therefore its omission from the Scrolls is to be expected. It would have been surplus to requirements."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("(ii)")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Josephus")]), _vm._v(": Reliance on the evidence of Josephus does not take us much further in our appraisal of Esther’s canonicity. Josephus states that there are twenty-two OT books, thirteen of which record the history of Israel from the death of Moses until Artaxerxes. In neither case does Josephus name the books that make up the numbers cited. While the very mention of Artaxerxes suggests Josephus knew Esther, this cannot be proved beyond reasonable doubt."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" What Josephus’ evidence does suggest is that the concept of canon existed at this time, even if diversity within Judaism allowed for non-universal canons.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  })]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  })])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("(iii)")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Early rabbinical evidence:")]), _vm._v(" There is limited evidence that a council "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("in Jamnia (Palestine) in "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("90 decided that Esther should be accepted.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The Mishnah (assembled in the first two centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(") gives directions about how the ‘Book of Purim’ should be read, suggesting Esther’s place had been established in the canon at least by the end of the second century. The Mishnah is important because ‘it forms the foundation for the Babylonian and Palestinian Talmuds. It therefore stands alongside the Hebrew Bible as the holy book upon which the Judaism of the past nineteen hundred years is constructed’."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("It is possible that the Palestinian Talmud implies that Esther’s canonicity was disputed as early as the second century on the basis that it advocates a festival not instituted in the Pentateuch."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Furthermore, Rabbi Samuel (third century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(") is cited as the source of a claim that Esther was not a sacred book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Finally assembled in the fifth or sixth centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(", the Midrash (a book containing collections of exegetical studies) contains commentary on Esther (along with the Pentateuch, Lamentations, Songs and Ruth). There are two relevant Midrashim: Esther Rabbah 1 (which expounds Esth. 1 and 2) and Esther Rabbah 2 (which expounds Esth. 3:1 – 8:15)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The interpretation of this evidence is varied. While it may imply a reluctance to accept this book, it may alternatively suggest that interest in Esther, and its distinctive nature, was aroused from the outset. Certainly if we accept an early date for the establishment of the OT canon, then the rabbinical debates concern a book already established in the canon (and questioned by a minority), rather than a book seeking to make an entry (and questioned by the majority). Indeed, the canonicity of Esther is rarely a matter of debate after the first four centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(", and it has been argued that Esther became one of the most important books outside the Pentateuch in later Jewish circles.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Christian sources provide some further information. Early evidence comes from Melito (Bishop of Sardis), who in "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("170 omits Esther from his list of canonical books (which otherwise reflects the present canon). In the writings of the early Church Fathers, there is silence in both commentating and referring to Esther. But Esther was affirmed by the church councils of Hippo ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("393) and Carthage ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("397), and at this point the Christian church considered the canon of the whole Bible to be established. Prior to this, Beckwith (1985: 296–297) suggests that there was a split between the Eastern church, where Esther’s canonicity was questioned (for example, in the fourth centuries by Athanasius, Gregory of Nazianzus, Theodore of Mopsuestia) and the Western church, where Esther was widely accepted.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The evidence is obviously inconclusive, but it should be remem"), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("bered that the distinctive content and character of Esther might itself account for uncertainty about its status.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Over the centuries there has always been interest in Esther. We know that in the early Middle Ages Rhabanus Maurus (Bishop of Mainz, ninth century) wrote a commentary on Esther. Luther ("), _c('i', [_vm._v("Table Talk")]), _vm._v(", 1914; see Laniak, 1998) seemed to dislike the book of Esther and accused the story of impropriety and excessive Judaizing. Even today modern scholars make similar complaints, adding to Esther’s sins that of gratuitous violence (see Pfeiffer 1948, Eissfeldt 1965 and even the Jewish scholar, Sandmel 1978).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("However, the book of Esther remains central to Jewish festival liturgy, and Christian theologians today appreciate its historical progress into the canon as a sign of its centrality and importance within the faith story of God’s people.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Position within the canon")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("In Hebrew manuscripts, Esther is usually positioned as the last of the five scrolls ("), _c('i', [_vm._v("měgillôt). ")]), _vm._v("These books (Song of Songs, Ruth, Lamentations, Ecclesiastes and Esther) are read at the five major festivals of the Jewish year and were given the collective label ‘Scrolls’ by the tenth-century Tiberian Masoretes. In BHS these Scrolls follow Job and precede Daniel in the third section of the OT, the ‘Writings’ ("), _c('i', [_vm._v("kětûbîm")]), _vm._v("), which follow ‘Law’ ("), _c('i', [_vm._v("tôrâ) ")]), _vm._v("and ‘Prophets’ ("), _c('i', [_vm._v("něbî’îm).")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Christian Bible places Esther as the last of seventeen books of sacred history. It opens with the formula "), _c('i', [_vm._v("wyhy ")]), _vm._v("(‘"), _c('i', [_vm._v("and it happened’ ")]), _vm._v("), typical of the history books (cf. e.g. Joshua, Judges, Samuel and "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Ezra). This means that the Christian Bible no longer places the five Scrolls "), _c('i', [_vm._v("(měgillôt")]), _vm._v(") together. In fact, over the years, Esther’s position in the Christian Bible has been variable (for example, it has also appeared at the very end of the OT canon, possibly reflecting the view that it was the last book to find its place within the OT canon).")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-002"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Relationship to the rest of the canon")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Thematically Esther has a number of connections with other material within the OT. Indeed, it is possible that its position in the Hebrew canon is connected to its theme. For example, the hope and celebration in Esther contrasts with and replaces the despair and mourning of Lamentations. Esther also connects with Daniel (which follows the "), _c('i', [_vm._v("měgillôt")]), _vm._v("), as both share a similar setting and plot, focusing on Jews prospering in a foreign land. The most obvious connections with other OT books relate to the emphasis that God’s people have a history and future because of God’s intervention. Thematic overlap exists with the stories of Joseph’s exploits in Genesis and more generally with the book of Exodus. With a more individual focus, Job and Ruth also investigate the theological theme of the apparent absence of God in the life of his people.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("When it comes to Esther’s relationship with the NT canon, we are confronted with the fact that Esther (along with Ecclesiastes and Song of Solomon) is not cited in the NT. However, recent studies by Beckett (2002) and Jobes (1999) have re-emphasized the possibility of typological interpretations of Esther (renewing some medieval approaches), even suggesting the possibility of Esther representing a type of Christ as servant of the Lord.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Esther has many parallels with the apocryphal book of Judith. Judith means ‘Jewess’, which in turn implies devotion to her nation’s cause. Written c.150 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", the book tells the story of Judith, a beautiful woman, who causes the downfall of Nebuchadnezzar’s chief general. Like Esther, the hopeful theme is that God will deliver weak people who trust him.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Other connections to the Apocrypha relate to the Greek additions of 106 verses that have a reverential tone and exalt God’s righteousness (see ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen8#appen-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")]), _vm._v(").")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("5. Literary issues")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Since the 1980s, the literary features of the book of Esther have received scrutiny. It has been recognized that it is impossible to determine the message of the book without paying due respect to the medium of that message, the written text itself. The features of the text, and the style adopted by the author, give us clues about the writer’s approach and message. The writer’s choices in terms of emphasis, mood, tone, structure and language, reveal something of the central theme and purpose.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("On a surface reading, the book of Esther is clearly a narrative. It tells a story and invites its readers to witness the unfolding drama. The story is given a historical setting but contains evidence of descriptive poetic licence and creativity. The story-line is clear and accessible. It has a beginning, middle, and end. Its basic elements are not complicated but its characters are as intriguing as they are straightforward. The reader quickly becomes aware of the author’s own evaluation of the rights and wrongs of the events, and the reader’s own sympathy is evoked. In other words, Esther is a good short story, a sound piece of literature, an attractive literary unit. But, however satisfying a surface reading is, by probing its literary features we access the writer’s meaning and purpose and can interpret the text in such light. Because we are looking at a canonical text, this interpretative task is always the goal of our study rather than the pure literary pursuit, but the latter enables the former to be pursued with more confidence.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("i. Genre")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The struggle to identify literary genre is the struggle to apply a label to the text as a whole. It’s all about asking the question, ‘what sort of literature is this?’ In the case of Esther, numerous solutions are proposed. Esther has been described as conforming to many literary types. These seem to fall into the following main categories:")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('i', [_vm._v("(a) Esther is non-fictional narrative ")]), _vm._v("(historical narrative or historical novel). By calling Esther a historical narrative, it implies that the book contains an accurate account of a series of events that took place at the stated time and place. Particular attention is paid to the historical features of the text and the historical framework of the ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("narrative, and the conclusion is that the primary purpose of the book is to record history accurately.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("The label ‘historical novel’ has similar but not identical implications. This genre allows for the recognition of the historical setting of the book, while also recognizing the literary creativity that the writer employs. In other words, the author is writing about history, but with a degree of poetic licence. So the writer has historical interests but also literary interests. Something of historical importance is being told, but in a creative way. Every detail serves either historical or literary interests, but we need to determine which. Understanding Esther as a historical novel does not deny the importance of history in Jewish and Christian faith; instead it underlines it. The writer is keen to record history in a memorable and interesting way, in order to stimulate identification with the unfolding drama and to remind the readers of their place in the continued line of God’s interaction with his people.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A historical reading of the Esther story seems coherent with the writer’s own intentions, for there are no indications in the text itself that the foundational events of the story are make-believe."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("(b) Esther is a fictional narrative ")]), _vm._v("(novella, Hellenistic novella, Diaspora novel). Understanding Esther as a fictional narrative allows us to view the book primarily as a creative short story. The story is enhanced by its assigned historical setting, but its setting is not indicative of its historicity. In other words, the story was written for purposes other than historical ones. For example, it could be argued that Esther was written for didactic purposes – to give God’s people hope during the Diaspora or to teach them about his faithfulness even when overwhelming odds seem stacked against them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The label ‘novella’ is used of short novels or long "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("stories and has been applied to Esther. Some prefer the title ‘Hellenistic novella’ in an attempt to parallel Esther with the Hellenistic romance tales.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" By understanding Esther in this way, the story is viewed as fictional – a story created for its meaning, a fable perhaps.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("(c) Esther follows other contemporary literature forms ")]), _vm._v("(Persian chronicle, Greek romance, carnival tale, festival aetiology). There have been many attempts to link the genre of Esther with other known contemporary genres. These labels normally imply something about the historicity of the book. For example, if we agree that Esther is written as a Persian court chronicle (or historical annal), then its adopted genre underlines its historical intentions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Similarly, if Esther mirrors Greek romance novellae, its fictional nature is acknowledged by the form it borrows. To understand Esther as a carnival tale or festival aetiology is to suggest that the writer’s intention specifically focused on the needs of the Jewish community, by regulating and explaining the carnival/festival of Purim.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The interesting feature about these genres and their application to Esther is that each does have parallels with specific parts of the Esther story, but none seems to be applicable to the text as a whole. This has led some critics to suggest that the text of Esther combines various shorter texts of different genres and origin. "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Alternatively, we might simply accept that the writer of the Esther story relied not on different sources but rather on different literary forms, without slavishly adopting them. So, for example, while the text of Esther may mirror Greek novels in structure and form, the romance and adventure elements so common in this genre are absent in Esther.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('i', [_vm._v("(d) Esther follows other biblical literary forms ")]), _vm._v("(wisdom tale, narratized lament). It has been long recognized that Esther contains elements of the outlook that characterizes wisdom literature. In particular, the "), _c('i', [_vm._v("ad hoc ")]), _vm._v("mentality, lack of historical depth and underdeveloped characterization are proposed as shared features.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Similar commonality has been found between the Esther and Joseph narratives – in particular, the fact that the reversal of fortunes motif is prominent in both. Other similarities have been noted between the practical focus of Proverbs and the pragmatic wisdom of Esther. The underlying assumption of Job that righteousness leads to well-being and wrong-doing to disaster is also mirrored in the plot of Esther as Haman falls and Esther rises. Laniak’s work comparing Esther with the laments of the Psalms is particularly fruitful. Laniak suggests that understanding Esther as a type of narratized lament, based on the poetic lament structures of the Psalms, provides potential for inter-textual readings. In particular, he draws out the significance of the four ‘movements’ of biblical laments: crisis, period of abandonment, reversal, state of favour (Allen and Laniak, 2003: 171).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("(e) Esther is a unique literary form ")]), _vm._v("(burlesque, comedy tale). Even on a surface reading the comical elements in Esther are striking. The portrayals of Ahasuerus and Haman as buffoon and megalomaniac respectively, the amusing coincidences, parallels and reversals, and the mockery and ironic exaggeration are common indulgences of the text, which betray comical intentions. Adele Berlin (2001: xix) suggests that Esther is a particular type of comedy tale – ‘burlesque’. This term distinguishes Esther from satirical forms of comedy, because its purpose is entertainment (or creating the ‘feel-good’ factor) not "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("critique. As burlesque, Esther naturally incorporates a tone of mock dignity, exaggerated descriptions, a series of ludicrous coincidences, underdeveloped characters and caricatures, and universal reversals. This does not deny that there is a deeper message in Esther, but means that the features and meaning of that message are understood only if the comic qualities of its genre are recognized.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("In the end it is perhaps wise to agree with Laniak (1998: 169) that ‘Esther is a text in which the cross-fertilization of various genres should be appreciated.’ In many ways Esther is unique within biblical literature, and its uniqueness is recognized by the sheer number of suggestions about its genre. To interpret the text appropriately it is advisable not to put the text in a genre straitjacket, but to be alert to the plethora of possibilities. To a certain extent the genre-quest is self-validating. Even though it may not yield a definitive answer, the search highlights a range of interpretative possibilities that allow us to penetrate beneath the surface reading of the text.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("ii. Structure")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Various understandings of the structure of the Esther narrative have been proposed. The very existence of numerous approaches underlines the growing acceptance that meaning cannot be separated from form when it comes to text analysis. For this reason, structural analysis is both critical and dangerous. It is dangerous because we may give too much credit to our structural conclusions, which may in turn distract from the text’s meanings; it is critical because without it we may miss vital clues about the text’s meaning. Fox (1983: 292) works with this perspective in mind and begins his analysis of Esther’s structure by stating, ‘The purpose of this study is to show how Esther’s literary architecture expresses the author’s world-view and even hints at his theological viewpoint.’ For Fox the ‘guiding principle’ of the structure of Esther is the theme of reversal,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" based on the phrase in Esther 9:1, ‘now the tables were turned’. This verse itself interprets the events of the story – it is a summary statement emphasizing that events have taken an unex"), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("pected and complete turnaround. The resulting structural analysis is one based on thesis and antithesis (see ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/pre6#tab36"
    }
  }, [_vm._v("here")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As the text’s own interpretation (evidenced by 9:1) demonstrates, the status of the reversal theme in the story’s structure must be taken seriously. In Esther this reversal motif has providence at the centre: the reversal occurs because actions of powerful people are overturned by similar actions from a different power source. Although God’s name is never mentioned, the implication is that such power and providence can only be divine."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("An alternative interpretation of the design of Esther is centred on the place of the Hebrew word "), _c('i', [_vm._v("mišteh ")]), _vm._v("in the narrative. This word is translated as ‘feast’ or ‘banquet’, and occurs nearly as many times in Esther as it does in the rest of the Old Testament books put together. In Esther, the story is both introduced and concluded by the theme, and the motif supports the main action. In this way, the feast motif serves to establish a satisfying literary quality that cannot be ignored – for there is something aesthetically pleasing about reading a story with this balancing and unifying feature.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These two structural interpretations can be brought together in a way that enhances our appreciation of the text’s architectural meaning. It is possible that these two literary themes, reversal and feasting, themselves reflect an overriding motif, the interface between God’s providence and human behaviour. This, after all, is one way of interpreting the significance and centrality of Esther in the story. Esther herself is subject to the forces of human behaviour and God’s providence as they meet in her lifetime. As human behaviour is reflected in the series of feasts, God’s providence is "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("reflected in the reversal of fortunes, which Esther’s actions enable her people to experience and celebrate in renewed feasting. The journey of God’s people is one of varied emotions: their lack of participation in the festivities of Ahasuerus’ court turns into full participation in the grief caused by his court’s decisions. This grief is then totally overturned by full participation in joyful celebrations of their deliverance. So these two aspects of the narrative’s design are linked in the character of Esther. She participates in the "), _c('i', [_vm._v("status quo ")]), _vm._v("to effect change for her people who are God’s people, in a way that points to the story’s theological meaning.")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab36"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "7",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "50%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "topbot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('b', [_vm._v("Thesis")])])]), _c('td', {
    staticClass: "topbot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_c('b', [_vm._v("Antithesis")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("3:1")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("King Xerxes honoured Haman … giving him a seat of honour higher than that of all other nobles.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("10:3")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mordecai the Jew was second in rank to King Xerxes, pre-eminent among the Jews…")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("3:10")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("So the king took his signet ring from his finger and gave it to Haman…")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:2a")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("The king took off his signet ring, which he had reclaimed from Haman, and presented it to Mordecai.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("3:12")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Then on the thirteenth day of the first month the royal secretaries were summoned. They wrote out in the script of each province and in the language of each people all Haman’s orders to the king’s satraps, the governors of the various provinces and the nobles of the various peoples. These were written in the name of King Xerxes himself and sealed with his own ring.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:9–10a")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("At once the royal secretaries were summoned – on the twenty-third day of the third month, the month of Sivan. They wrote out all Mordecai’s orders to the Jews, and to the satraps, governors and nobles of the 127 provinces stretching from India to Cush.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("These orders were written in the script of each province and the language of each people and also to the Jews in their own script and language.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mordecai wrote in the name of King Xerxes, sealed the dispatches with the king’s signet ring…")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("3:13")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Dispatches were sent by couriers to all the king’s provinces with the order to destroy, kill and annihilate all the Jews – young and old, women and little children – on a single day, the thirteenth day of the twelfth month, the month of Adar, and to plunder their goods.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:10b–12")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("… and sent them by mounted couriers, who rode fast horses especially bred for the king. The king’s edict granted the Jews in every city the right to assemble and protect themselves; to destroy, kill and annihilate any armed force of any nationality or province that might attack them and their women and children; and to plunder the property of their enemies. The day appointed … was the thirteenth day of the twelfth month, the month of Adar.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("3:14")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("A copy of the text of the edict was to be issued as law in every province and made known to the people of every nationality so that they would be ready for that day.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:13")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("A copy of the text of the edict was to be issued as law in every province and made known to the people of every nationality so that the Jews would be ready on that day to avenge themselves on their enemies.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("3:15")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Spurred on by the king’s command, the couriers went out, and the edict was issued in the citadel of Susa. The king and Haman sat down to drink, but the city of Susa was bewildered.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:14, 15b")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("The couriers, riding the royal horses, raced out, spurred on by the king’s command. And the edict was also issued in the citadel of Susa … And the city of Susa held a joyous celebration.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("4:1")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("When Mordecai learned of all that had been done, Mordecai left the king’s presence wearing royal he tore his clothes, put on sackcloth and ashes, and garments of blue and white, a large crown of gold went out into the city, wailing loudly and bitterly.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:15a")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("Mordecai left the king’s presence wearing royal garments of blue and white, a large crown of gold and a purple robe of fine linen.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("4:3")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("In every province to which the edict and order of the king came, there was great mourning among the Jews, with fasting, weeping and wailing. Many lay in sackcloth and ashes.")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("8:17a")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("In every province and every city, wherever the edict of the king went, there was joy and gladness among the Jews, with feasting and celebrating.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("5:14a")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("His wife Zeresh and all his friends said to him, ‘Have a gallows built, seventy-five feet high, and ask the king in the morning to have Mordecai hanged on it. Then go with the king to the dinner and be happy.’")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("6:13b–14")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("His advisers and his wife Zeresh said to him, ‘Since Mordecai, before whom your downfall has started, is of Jewish origin, you cannot stand against him – you will surely come to ruin!’ While they were still talking with him, the king’s eunuchs arrived and hurried Haman away to the banquet Esther had prepared.")])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("6:6–9")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("(Haman thinks he is to be honoured and designs an honouring ceremony.)")])]), _c('td', {
    staticClass: "bot",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("6:10")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_gauche"
  }, [_vm._v("(Mordecai receives the honour Haman had designed.)")])])])])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("iii. Style")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("The story of Esther is written from the narrator’s point of view. Clues to the characteristics of the narrator’s representation are gained from looking more closely at stylistic features, such as the characterization, language, pace and mood of the story.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" It is clear that the narrator adds his own insight to the Esther story: he interprets the characters’ thoughts and feelings and, of course, designs the story and adopts language that supports his perspective.")]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-001"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_vm._v("a. Characterization")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One of the striking features of characterization in Esther is that the characters emerge not through their own words but through the narrator’s words. There is very little direct speech in the book (in clear contrast to the book of Ruth, for example). So Mordecai has only one short speech (4:13–14), despite his important role in the story. The reader does not eavesdrop on conversations so there is a distance between the reader and the story. The narrator seems more concerned with action than with characterization, conveying information rather than provoking empathy. So it has been suggested that it is only Esther who develops in any sense as a character. The other characters are static. They remain what they always "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("were and they are typecast. There is similarity with the traditional typecasting of the wicked and the righteous in the wisdom literature. So, for example, we see Haman as wicked and full of folly and misdirected aggression; Mordecai, on the other hand, is righteous and wise, and his anger is channelled in the right direction and in the right way.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" In particular, righteous people react with a sense of proportion to the circumstances facing them, whereas the wicked have no sense of proportion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" It is sometimes argued that flat characters best suit the comic genre of the story, for it makes the characters themselves unreal and suggests that they should not be taken too seriously. While this may help to understand the priority of the narrator – action rather than characters – in some senses the story of Esther is the story of its characters, and therefore what we discover about them should not be overlooked.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We gain most of our insight about Xerxes (Ahasuerus) from the descriptions of how his court operates. He emerges as a bumbling and self-indulgent man, motivated by his own sensual appetites. His court is regulated and bureaucratic, but escapism and merriment dominate his horizons. The operation of the court centres on the king’s whim, making for an uncertain and unpredictable environment. Most of all, the king is capricious and malleable, without personal conviction."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" His exposure in the first two chapters of the book sets the scene: the Jewish people are dangerously vulnerable. Xerxes is the only character who is around for the "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("duration of the story: the constant is that just as he was only apparently in charge at the start, so also at the end, though now Esther and Mordecai have assumed control rather than his courtiers.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Haman is not bumbling, he is evil through and through. When he is introduced, his honour is mentioned first (3:1), but any optimism about this man quickly disappears through Mordecai’s response to him (3:2) and then by the unveiling of his irrational anger and plans (3:5–6). Insight into Haman’s inner thoughts exposes all that he is, and like the exposure of Xerxes, this adds tension and irony to the story. The narrator does not allow his readers any doubt: Haman is doomed from the outset and we are to enjoy witnessing his downfall. The narrator aligns himself in opposition to Haman, allowing the heroine Esther to denounce him in a dramatic declaration before the king (7:6), after which Esther’s term is adopted and Haman is labelled ‘the enemy’ (8:1; 9:24). Chapter 6, often seen as pivotal in the story, portrays a man with a reeling and tortured mind subject to the irrational forces of his own wickedness. In this chapter he is transparently devious. Although Haman himself is irrational, his downfall is completely rational – he cannot be protected from himself, and his death on his own gallows (ch. 7) is both ironic and inevitable.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("In contrast, Mordecai is protected by some degree of mystery. We are not told the motivation for his actions, nor are we given clues about his emotional state (for example, we are left to guess why he refuses to honour Haman, 3:2). The narrator protects Mordecai from too much scrutiny, and in this way preserves his heroic status. Mordecai’s characterization doesn’t really develop, although his leadership qualities are universally recognized at the end. Instead, he remains a constant example of personal strength, integrity and conviction. He is a man of neither whim nor irrationality, and acts as a counterbalance to the instability depicted through the characters of Xerxes and Haman. It is Mordecai’s actions that distinguish him from those around him: he is an exceptional man of his times and even Haman cannot ignore him (5:13). He is also ‘of the Jewish people’ and it is left to Zeresh to voice this reality and its significance to her husband (6:13).")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Uniquely in this book, the characterization of Esther has move")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("ment and development. Esther begins as a pawn in a volatile game. She is subject to other people’s expectations and whims, and things happen to her rather than through her. However, even in the early stages of the narrative there are hints that there is more to Esther than passivity and outward beauty (2:7), as she ‘wins’ favour (2:9, 15). By the middle of the story it is clear that Esther is intelligent, courageous and persuasive (chs 4 and 5), and she now starts to give the orders (4:15) and dictate the actions and schedules of both the king and Haman (ch. 5). By the end of the story Esther’s rise as the story’s heroine is complete: she assumes control (ch. 8); and she is now the one who writes a decree ‘with full authority’ (9:29). She devises a strategy and executes it, and her real strength of character emerges with the story’s outcome. This character development enables the reader to identify with Esther. She is human – not always strong. At a decisive moment she resolves to act (4:15) and thereby turns around her life and the lives of others. In this sense she is the inspirational character of the story – one to whom the reader can aspire.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("The other characters, Vashti, Zeresh, the court officials, the Jews as a whole, play supportive roles as agents moving the plot along or providing contrasts and pairings with the other characters. As a group, these human characters are subject to providential events: the coincidences of the story in which they take part point to the limitations of their power. These coincidences, and the unlikely outcome of the story, force the reader to think about where power ultimately lies: what is God’s part in the story?")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-002"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("b. Language")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("One of the striking features of the book is the lack of religious language. There is no mention at all of God or his commands or his relationship to his people. This, along with the excesses in the language, makes Esther unique among the biblical books. This uniqueness is perhaps explicable in terms of the ironic comedy within the book and the carnival occasion with which the story became associated.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("The clearest example of exaggeration occurs in association with the numbers that appear in the story: 127 provinces, a 180-day plus 7 days party/banquet, 12 months of beauty treatments, ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("10,000 talents of silver and a stake measuring 50 cubits. The effect is to make the details ridiculous. Lists of unpronounceable names also appear (1:10; 1:14; 9:7–10), which slows the pace for the reader, leaving the impression that these names are deliberately ludicrous.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Dense repetition litters the text. The writer uses repetition as a form of emphasis and sometimes as a way of underlining the folly of the character involved. Chapter 6 exemplifies this. In Haman’s speech (vv. 7–9) the repetition highlights the devious contriving nature of the story’s villain, but then the repetition is continued as the king takes over, and ironically everything Haman planned for himself happens to Mordecai. In Chapter 5 the king’s own weakness is depicted by his repeated offer to Esther, ‘What is your petition … what is your request? Even up to half the kingdom, it will be granted’ (vv. 3 and 6). Esther wisely repeats Ahasuerus’ words back to him (vv. 7–8).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The hyperbolic style is furthered by the use of synonyms. On numerous occasions, the narrator says the same thing more than once by providing alternative words of similar or identical meaning. So on hearing the king’s edict, the Jews mourn with ‘weeping and wailing’ and in ‘sackcloth and ashes’ (4:3), and Esther describes the decree as selling her people ‘for destruction and slaughter and annihilation’ (7:4). Complementing this prolific use of synonyms are the dyadic expressions where the same word is used twice in one phrase to emphasize totality. In addition to the prolific use of "), _c('i', [_vm._v("kol ")]), _vm._v("(every), we have word repetition, so ‘every province’ is literally ‘every province and province’ (4:3), ‘every city’ literally ‘every city and city’ (8:17), ‘each man’ literally ‘man and a man’ (1:8) and ‘each province’ literally ‘province and a province’ (8:9).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("This style introduces sound patterns and alliteration to the text, just as the lists of unpronounceable names do. While such features are not unique to Esther, their prolific use in this narrative text results in a unique piece of literature.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-003"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("c. Mood")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("By the mood and tone of the text, folly and wickedness are ridiculed. That ridicule becomes even more effective because it is coupled with a sense of fun. Despite its subject matter there is lightness to the story – it is a story the Jews would love to tell and celebrate; it is made easy to bear. The mood is ironic and dramatic and is established through contrasts and reversals. In decisive moments, elaborate schemes are undone by unplanned coincidences. The result is a mood of optimism and expectation for its readers, as the downfall of the story’s villain begins to pan out. Not surprisingly the most ironic and dramatic moments in the story centre on Haman and his demise (for example, 5:12; 6:11; 7:8–10). In his demise is the elevation of Esther and Mordecai, and the optimism is realized.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-004"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("d. Pace")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("In the main the tempo is fast, the exception being the elaborate descriptions of the court as the narrative opens, carefully setting the scene for the story. Decisions are made with great speed: there is little time for careful reflection when Vashti is deposed (1:10– 22), when the decree about the Jews is issued (3:8–15), or when Haman gets whisked off to attend Esther’s banquet (6:14). The movement of characters is emphasized at the start and end of each scene, allowing the story to gather pace – there are no easy places to stop when reading this story. In addition, the reader has access to only the gist of speeches and edicts, for the gist is enough to allow the story to sweep on.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-005"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("e. Tension")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Despite the fast pace, some literary devices are used in the story to cause suspense and create tension. Esther’s insistence on a further banquet (5:8) holds up the events of the story temporarily. Then we reach chapter 6, which interrupts the story-line and prepares the way for the reversals to begin. Suspense is also created by the passive voice that dominates the early scenes, giving the impression that no one is in control and anything could happen. This said, suspense only works at a basic level – the irony ensures that the reader still expects good to conquer evil.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("These features of literary style (or as Brueggemann [2002: 360] prefers, ‘the artistic processes’) illustrate the writer’s concern to present his story in the way that best suits his intentions. It seems that the writer wanted his story to be told and re-told but also enjoyed and re-enjoyed, and his literary choices were part of his commitment to his readers.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-006"
    }
  }, [_c('h4', {
    staticClass: "int_niv3"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("f. Unity")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Advocating the unity of the book of Esther seems a viable position, despite the concerns that have been raised over the origins of chapters 9 and 10.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Certainly a sense of unity is maintained throughout the Hebrew text by the theological motifs (feast and reversal), which give the book its structural balance. However, there does seem to be a change of style at least at 9:20, where the rhetorical is replaced by a less flamboyant, direct style. The final form of the Hebrew text may indeed reflect different sources and interests, but it also stands in its final form as a coherent text with a historical core in which, possibly, religious, festival and pictorial dimensions have been successfully integrated. Whether these dimensions reflect the work of a single writer to suit his own purposes, or many writers to suit their own purposes, is debatable, but the text is clearly intelligible and meaningful in the Hebrew form in which it is preserved. Because of the unique combination of literary issues and stylistic features in Esther, it is inevitable that discussions about the book’s meaning and purpose will always be related to assessments of its "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("literary character. The way the story is told, as well as the story itself, testifies to its purpose, and the design of the text is both the instrument of its meaning and the instruction itself.")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("6. Textual issues")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The textual history of Esther is a complex issue. There are many different forms of Esther in different languages, which reminds us of the complicated history and development of the scriptural text. Most scholars now agree that there are at least four important witnesses to the story of Esther: the Hebrew Masoretic Text and three Greek versions.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" But behind these texts themselves is envisaged a variety of early text forms (both written and oral). The textual history is complicated by decisions made by the Christian church over many years, whereby various versions based upon diverse texts have either been accepted or refused acceptance into the canon.")]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-006"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("i. The Hebrew Masoretic Text")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Hebrew version of Esther is the shortest of the extant witnesses to its story. Additionally, the earliest manuscripts of the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("date from the eleventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("(a long time after the earliest Greek manuscripts), so we don’t actually possess an ‘original’ Hebrew text or anything like it. However, the Hebrew manuscripts are uniform in their presentation of the consonantal text of Esther. It wasn’t until the time of Jerome (fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(") that the Christian church became focused on uncovering the original Hebrew text of the OT canon. Until this point, the church accepted Greek versions as the texts they relied on. Jerome’s preference for translating and interpreting the Hebrew text of Esther was reaffirmed when the Vulgate became the Bible of the Western church. Additional sections of Esther without Hebrew manuscript support were relegated to an appendix. During the Reformation, there was a resurgence of interest in the Hebrew language, and it was the Hebrew text that was the basis for Luther’s own translation of the Old Testament (completed in 1534). Even "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("though there are uncertainties about its own sources,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" no one has doubted the importance of the Hebrew text as a witness to Esther’s story – it is, after all, the text followed by the Syriac and Aramaic versions – but the Greek texts too cannot be ignored.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("ii. The Septuagint ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")]), _vm._v(") or ‘B-text’")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This standard Greek translation of the OT was produced in the third to second centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC ")]), _vm._v("and is preserved totally in fourth-century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD ")]), _vm._v("manuscripts. Origen was certain that this translation was based on the original Hebrew text of the OT. Despite Jerome’s dissatisfaction with the text (he designated the additions of the Septuagint as deutero-canonical), it was afforded great importance by Augustine, who believed that because the Septuagint was the first Bible of the Christian church it should be universally accepted. It seems certain that the Septuagint was the Bible that the church used once the Christian message was taken outside Palestine by Paul and others. A Greek translation was necessary for non-Hebrew-speaking Christian converts, including Jews of the Diaspora. One of the implications, therefore, is that the Septuagint may reflect a Hebrew text earlier than the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v(", which would have had equal status with the current Hebrew text as sacred Scripture. The Septuagint of Esther has six main units of text, which are not reflected in the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v("; some appear to be Semitic in origin, others Greek. These have become known as the six ‘Additions’ and are referred to by the letters A–F."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Jerome’s removal of the Additions from his Vulgate text had the unfortunate effect of isolating the six texts from their place within the Esther story, so their context became unclear. The author of these Additions is unknown, though some of them are traditionally associated with Lysimachus who translated the text of Esther into Greek in about 114 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(". The Additions add new dimensions to the Esther story by their focus on "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("God and prayer, and by changing the story’s mood, movement and details in places. In particular, the name of God is introduced, Purim is not emphasized and the characterization of Esther is different. The resulting story is judged to be in line with the emphasis in Ezra/Nehemiah and Daniel, and whatever the purpose of the Additions, this similarity probably aided the canonical acceptance of Esther. The Septuagint certainly shows us how Greek-speaking Jews of the pre-Christian era read and understood the story of Esther, and therefore its witness to early Jewish interpretation cannot be disregarded. The Greek Additions are still an integral part of the OT canon for Roman Catholic and Eastern Orthodox churches.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("iii. The ‘A-text’ (‘L’ or Lucianic)")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Four Greek manuscripts (dating from the tenth–thirteenth centuries) preserve a text of Esther, again much longer than the Hebrew version. Originally, the text was thought to belong to the Lucianic recension (originating with Lucian of Antioch, d. 311/312), but this is now doubtful. It is possible that this text relies on the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")]), _vm._v(", but this is not certain.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" We might surmise that a proto- A text existed, without the Additions, which itself may have been based on a non-Masoretic Hebrew text. Such an explanation accounts for its connections with the Hebrew text, as well as the fact that it does not duplicate it. Although the history of the development of the A-Text is uncertain, it does bear witness to a form of the Esther story that was accepted among Greek speakers in the tenth–thirteenth centuries. Indeed Dorothy (1997) suggests that the A-text contains the earliest known form of the core tradition and therefore demands greater attention than it has received. He argues that the A-text adapts the Esther story to make it more palatable to a less-Hellenized community based in Palestine. He suggests that this explains the apparent Jewishness of the text when compared with the other known versions of the story. Indeed, in the A-text Esther makes no attempt to hide her Jewishness, God’s covenant with Abraham is repeatedly mentioned, and God’s acts of "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("deliverance are emphasized. The independent nature of the text is quite evident from these few examples of its uniqueness.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("iv. The version of Josephus")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This version of the Esther story in Josephus’ "), _c('i', [_vm._v("Antiquities ")]), _vm._v("(II.184–296) is important because of its early date (first century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v("). It has generally been portrayed as a paraphrase of the Hebrew version, but we should allow the possibility that Josephus’ version bears witness to a text other than the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v(". It is possible that the version relies on a ‘proto-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v("’ text or, of course, an independent tradition altogether. Josephus’ story is considerably longer than the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT ")]), _vm._v("and gives evidence of the text and interpretation of Esther in Josephus’ own era and setting. Josephus’ narrative adds its own frame narrative along with some details not found in other texts. However, because it does not contain Mordecai’s dream and its interpretation, and only has a précis of Esther’s prayer, its text is shorter than the Septuagint and A-text. Josephus offers a little less irony than the other forms of Esther. This may be explained in light of its character as historical narrative and its religious point – God watches over his people. Unfortunately, detailed research on the relationship of Josephus’ text to the other versions of Esther remains unfinished.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Recent studies of the textual history of Esther have encouraged us to appreciate more fully the independent nature of these textual witnesses. In particular, it is less acceptable simply to read the Greek texts as ‘supplements’, merely providing additions to a superior Hebrew text. If we accept that all four main texts are indeed separate books of Esther, or separate witnesses to the Esther story (evidencing different eras of textual transmission within the communities from which they come), then each witness should be allowed to inform our understanding of this story at least to some degree."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" The Protestant church needs to consider the implications "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("of this, but it at least re-emphasizes the role of the faith community at the centre of canonical decisions from the outset. We should remember that canonical discussions concentrated on listing canonical books rather than highlighting the particular textual version that was acceptable. For this reason, the various texts that bear witness to the Esther story have a vital role to play in informing our appreciation of the history of interpretation arising from diverse faith communities over the centuries.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("7. Theology and purpose")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Perhaps the most outstanding theological feature of the Hebrew text of Esther is that it makes no mention of God at all. For some, this means that it lacks theological value altogether, but its place within the canon denies the possibility of such a stark conclusion. Furthermore, fundamental to Jewish and Christian theology is the view that where God’s people are to be found, God is actively present, and certainly Jewish presence is central to the Esther story. So we need to grapple with why God’s name is not mentioned, while holding onto a theological perspective that prefers to talk about the ‘hidden’ God in the text rather than the ‘absent’ God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Early attempts to understand the omission of the divine name in Esther concentrated on the nature and content of the text of Esther and its use by the Jewish community. There was the suggestion that the party atmosphere of the Purim festival was an unsuitable context for God’s name to be mentioned. This seems an unsatisfactory explanation, especially as liturgies of this festival include words of blessing which use God’s name both before and after the reading of the Esther text. The non-mention of God’s name has also been explained by looking at the book’s genre (e.g. the absence of God’s name is to be expected in a book designed as a Persian chronicle")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v("). This line of argument also has circularity as its weakness, especially when we consider that assigning the book to this literary form has already taken into account its apparently non-religious character. Further, it has been argued that Esther is primarily a story of non-"), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("religious nationalism, and the inappropriate behaviour of God’s people in the story itself demands that God is hidden. Some of these perspectives pay more attention to the content of the story than to the author’s design or purpose. It is certainly feasible that the story does not mention God’s name because the author assumes God’s presence rather than mentions it. Equally, it could be maintained that the author is concerned with leading readers to their own faithreading of the text, rather than imposing such a reading.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Here I believe we move closer to the author’s intentions. We have already seen that the author adopted a style and genre that encourage the story to be told and re-told, enjoyed and celebrated. The style causes the reader to feel involved in the story, somehow participating in its journey, but with attention on the story’s movement and outcome rather than on individual details. We have noticed the testimonial value of the text – the theme of salvation and reversal is a testimony to preservation despite the odds – and this is surely the significance of the story within the Jewish cycle of festivals. Accounts of salvation are always faith-creating and faith-confirming, and somehow Esther conforms to this norm without the necessity to identify that it is God’s hand at work. In other words, the text serves as an invitation. It is as if the author says, ‘I am inviting you to hear this story and to respond to it with faith.’ This journey to faith requires pondering the events, searching for God within the plot, and choosing to see his active presence. So the story ‘veils’ God’s presence rather than hides it, teasing the reader to look beyond the veil to the greater reality that can be uncovered through searching.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" The story requires a response to the mystery of the veiled presence of God. This response is faith-creating and faith-building, for it is a personal and individual response rather than a second-hand one, built only on the author’s own interpretation of the story. But what sort of faith is encouraged by the story? Certainly such faith conforms to the basic tenets of Christian theology, incorporating at different levels some key theological assertions:"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-010"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("i. God is working his purpose out")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("The providence of God is hinted at through the use of coincidence and surprise within the text. Coincidences occur which are left unexplained but which dictate the outcome of the story as it moves towards the moment of reversal and resulting salvation. So, for example, Esther is in the right place at the right time when Vashti is deposed (2:8) and when Haman’s evil plans come to light (4:14b). When the king cannot sleep and asks for his historical records to be read, they happen to fall open at the page that highlighted Mordecai’s role as the one who foiled an evil plot against the king (6:1–2). As the king considers what to do, it just so happens that Haman is standing outside (6:5), and the resulting honour to Mordecai fuels Haman’s anger. The frequency of such coincidences promotes the legitimacy of a theological reading of the text in which the providence of God is at work. Furthermore, because the path of this story does not conform to human expectations and there are elements of surprise that defy human explanation and reason, such a reading seems to be encouraged. In Esther the ultimate surprise is that ‘the tables were turned’ (9:1). This phrase interprets the great moment of reversal in the story, and although the text says that the Jews now get the upper hand, no subject is identified as the over-turner of tables. In Christian theology, God is often identified as the one who brings reversal. He turns darkness into light, mourning into rejoicing, defeat into salvation and death into life. In the lives of God’s people, such reversals defy human explanation and reason, whether they happen in the lives of individuals (like Joseph, Daniel, Hannah, Saul and Jesus himself), or to groups of his people (from wilderness to Promised Land, from exile to return, from the place of crucifixion to the place of resurrection). They serve as examples of the dramatic intervention of God bringing about his purposes through his people’s preservation and ultimately by his Son’s gift of salvation to the world.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("A reading of the text that allows a providential focus makes sense of the place occupied by this text in the history and life of the Jewish people. At this point in their history, the Jews clung onto the hope that God’s providential hand guarded their lives, despite the external forces to which they were subject. To read the story of Esther without this perspective makes the story more, not less, incredulous. As Purim festivals were celebrated in each year of their perilous history, the story of Esther served as a reminder that even in their darkest days God’s people could trust in the providential care of a covenant God who had promised to be with them for ever.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-011"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("ii. God is presently active in the world")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("It seems undeniable that the world-view of the Esther story includes the belief that God is actively present in the world. This is the hope that makes sense of the story’s ‘lightness’. There is optimism from the outset that the Jewish people will survive, and in this story that belief is not linked to the return to Jerusalem, to the adherence to cultic practices, or to the emergence of an expected Messianic figure. In Esther the active presence of God goes beyond these boundaries of geographical and religious expectations. God is actively present in the world of Esther and Mordecai. They too, in a foreign land subject to secular rulers and régimes, can become instruments of God’s active presence. As Israel’s history unfolded, the story was relevant not only to the original community of its setting but to every generation since. It demonstrated in practice the universal and eternal operational presence of the covenant God who lives up to his name: Yahweh, the one who is eternally active and present in the world.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-012"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("iii. God works with human behaviour and responses to him")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Esther’s story illustrates that God can work with or without human co-operation. While it is necessary for Esther to make the conscious decision to take up the challenge to work for God’s people (4:16), it is not necessary for Haman to actively pursue God’s purposes in order for God’s people to be saved. Anderson (1950: 40) puts it this way: ‘even the most disreputable characters and flagrant violators of his will are bent into the service of his ultimate purpose.’ In other words, God’s purpose may include human agents, but its success does not depend on who those agents are or what they do. Esther herself is not flawless in the story: hiding her identity contradicts Jewish law; the process of becoming Xerxes’ queen is unsavoury; instituting laws that are vicious appears morally indefensible. But God works with these human responses as his sovereign will for his people emerges.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-013"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("iv. God protects and saves his people")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("The story’s meaning is clearly tied up with the perspective that Israel occupies a protected and privileged place within God’s purposes.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" This is what gives the story its timeless quality. The Jews would continuously remind themselves of the events in the book of Esther because they are eternally illustrative of a theo-logical reality: God saves his people. The story dramatizes theology, and this dramatic presentation is worthy of the miraculous nature of the salvific act it records.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Theologically the question remains: does the intrinsic value of the text lie in its message about the Jews or its message about their Saviour? In other words, is the story primarily about God or his people? Of course, for the covenant community there was no such dichotomy: God is defined by his people, and they by him, just like "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("a shepherd is known by his flock, and the flock by him (Ezek. 34). So the people of the holy God are called to be a holy people (Deut. 7:6), and the significance and direction of history is tied up with God’s relationship to his people and theirs to him. When God intervenes in their lives, his nature as well as their status are revealed.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These observations are certainly compatible with the view that the purpose of the story’s place in the canon relates to its faith-creating role. It is because God can be trusted as Saviour that his people can exercise faith that is saving. For its original readers, for Jewish people and for Christian readers, Esther becomes part of their "), _c('i', [_vm._v("Heilsgeschichte ")]), _vm._v("(salvation history), the reason for their faith. It promotes trust in a God who saves all people who turn to him in faith. This life of faith and trust is the real promised rest for which his people longed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-014"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("v. God’s people can celebrate")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The book of Esther does not hold back: when good things happen, even miraculous things, God’s people will rightly celebrate (8:16– 17). The institution of the festival of Purim provides an opportunity for God’s people to celebrate regularly (9:18–22). It reminds them that evil was defeated, and such a victory parades laughter and enjoyment as suitable emotional responses. There is little solemnity in the Purim festival, but lots of hilarity and celebration. The evil context in which victory came is subsidiary and that evil itself is reversed by the generosity that marks the festival (9:22). Within the OT, gratitude to God and trust and confidence in him leads to deep joy that pervades worship. Frequently such "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("trust and joy emerge from dire circumstances, as the Psalms often show us.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen10#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" It is important to note the commendation of celebration in the Esther text. Throughout history, God’s people are called to exercise the faith to rejoice in God in all circumstances, but certainly to respond to acts of deliverance with celebration and praise.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-015"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("vi. God calls his people to faith")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Purim festival is a reminder that Jewish history results in a faith that needs to be practised. There is no point knowing history but not living in the light of that history. Faith for the ‘here and now’ makes sense of the ‘there and then’. The purpose of divine activity meeting human behaviour correlates to the faith that is produced. Esther is arguably a role model of faith and piety, but her story is more than that: it promotes faith and piety. It is a story that encourages every reader to understand ‘what is going on’ in ‘what is going on’, and to respond accordingly with a life of faith and devotion. Every situation, whether or not God’s presence and power can be seen or felt, is an opportunity for a divine encounter, a place to experience God’s intervention, and therefore is a situation worth experiencing.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Perhaps the author of Esther is determined that God’s presence remains ‘veiled’ in the text because this is the very point. Perhaps the author’s own faith journey has been one where the presence of God has never been particularly evident. Is the author encouraging us to be people of faith even when our most common experience is at best that God is hidden? Is he in fact saying that this is what life and faith are normally like? Visions and revelations might come and go (as the apocalyptic literature suggests), but the veiled presence of God is a constant that may not be seen and felt but will always sustain his people in good, bad and ugly times. This is the precious truth that Esther’s story celebrates.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("The author of Esther is calling readers to ‘do theology’ – to reflect on God’s nature and his seen or unseen role in history. But ‘doing theology’ also includes responding to the implications of such a quest, and this responsive task will even today require individual and corporate faith as a heart response to God’s selfrevelation.")])])])])])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31094265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre6.vue
// module id = 78
// module chunks = 0